__turbopack_context__.v({
  "root": "ShopSidebar-module__2GWW3G__root",
});
